module.exports = __webpack_public_path__ + "img/qywh2.d22bf70c.jpg";